<br *ngIf="bandSlider===true">

<div id="carouselFOI" class="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="3000"
    [hidden]="bandSlider === false">

    <div class="carousel-indicators">
        <button type="button" data-bs-target="#carouselFOI"
            *ngFor="let item of tier3Data;let index = index; let isFirst = first" [attr.data-bs-slide-to]="index"
            [ngClass]="{ active: isFirst }">
        </button>
    </div>

    <div class="carousel-inner">
        <div class="carousel-item" *ngFor="let t3d of tier3Data; let index = index; let isFirst = first"
            [ngClass]="{ active: isFirst }">
            <ng-container *ngIf="t3d.img!=null">
                <ng-container *ngIf="verifiedImgDirectory(t3d.img)">
                    <img src="{{URL}}{{t3d.img}}" class="d-block w-100" alt="">
                </ng-container>
                <ng-container *ngIf="!verifiedImgDirectory(t3d.img)">
                    <img src="{{t3d.img}}" class="d-block w-100" alt="">
                </ng-container>
            </ng-container>
            <ng-container *ngIf="t3d.img==null">
                <img src="../../../assets/imgNotFound.png" class="d-block w-100" alt="">
            </ng-container>

            <div class="carousel-caption">
                <ng-container *ngIf="verifiedLength(t3d.t3longtitle)">
                    <div class="Title-slider" [routerLink]="['../ficha/'+ t3d.code]" target="_blank">
                        {{t3d.t3longtitle}}
                    </div>
                </ng-container>
                <ng-container *ngIf="!verifiedLength(t3d.t3longtitle)">
                    <div class="Title-slider" [routerLink]="['../ficha/'+ t3d.code]" target="_blank">
                        {{t3d.shorttitle}}
                    </div>
                </ng-container>
                <ng-container *ngIf="t3d.iddpto">
                    <div class="field-of-interest" [routerLink]="['../ficha/'+ t3d.code]" target="_blank">
                        {{t3d.dpto}}
                    </div>
                </ng-container>
                <ng-container *ngIf="!t3d.iddpto">
                    <div class="field-of-interest" [routerLink]="['../ficha/'+ t3d.code]" target="_blank">
                        {{t3d.longtitle}}
                    </div>
                </ng-container>
            </div>

        </div>
    </div>
</div>